import { render, staticRenderFns } from "./VenueOld.vue?vue&type=template&id=3b3adcb6&scoped=true&"
import script from "./VenueOld.vue?vue&type=script&lang=js&"
export * from "./VenueOld.vue?vue&type=script&lang=js&"
import style0 from "./VenueOld.vue?vue&type=style&index=0&id=3b3adcb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3adcb6",
  null
  
)

export default component.exports